module.exports = __webpack_public_path__ + "img/f3-5.505efb8e.png";